import { isNumber, isString } from 'lodash-es';

import { validateCSSSize } from './validate-css-size.js';

const PX_UNIT = 'px';

/**
 * Coerces a string or numeric value into a valid CSS size length value (width, height, etc.)
 * If the value is numeric it will assume that is expressed in pixels
 * @param value - the value to coerce.
 *
 * @internal
 *
 */
export function coerceSizeValue(value?: string | number): string | undefined {
  if (isNumber(value)) {
    return `${value}${PX_UNIT}`;
  }

  if (isString(value)) {
    return validateCSSSize(value);
  }

  return undefined;
}
